 import Client from "./client";
 import _ from "lodash"

export default class Media {
    constructor() {
        this.client = new Client()
    }

    async list(data) {
        return this.client.http().post('/v1/dms/media/list', data)
    }

    async upload(data) {
        let formData = new FormData();

        let count = 0
        data.files.forEach((file, index) => {
            formData.append('file', file)
            count++
        })

        if (count == data.files.length) {
            formData.append('path', data.currentDir)
            formData.append('ref', data.ref)
            formData.append('replace', data.replace ? 'true' : '')

            if (data.expiresAt)
                formData.append('expiresAt', new Date(data.expiresAt).toISOString())

            if (!_.isEmpty(data.metadata))    
                formData.append('metadata', JSON.stringify(data.metadata))


            if (data.isPublic) {
                formData.append('is_public', data.isPublic)
            }

            return this.client.http().post(`/v2/dms/media/upload`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
        }
    }

    async delete(data) {
        return this.client.http().post('/v2/dms/media/delete', data)
    }

    async uploadBase64(data) {
        return this.client.http().post(`/v2/dms/media/upload`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
    }

    async share(lib, data) {
        return this.client.http().post(`/v2/dms/media/library/${lib}/upload/share`, data)
    }

    async download(lib, key) {
        return this.client.http().post(`/v2/dms/media/library/${lib}/download`, {key}, {
            responseType: 'blob'
        })
    }

    async createDir(lib, path) {
        return this.client.http().post(`/v2/dms/media/library/${lib}/dir`, {path})
    }

    async deleteDir(lib, path) {
        return this.client.http().post(`/v2/dms/media/library/${lib}/delete/dir`, {path})
    }
}